export const TOGGLE_DELIVERYDAYS = 'TOGGLE_DELIVERYDAYS';
export const SHOW_DELIVERYDAYS = 'SHOW_DELIVERYDAYS';
export const HIDE_DELIVERYDAYS = 'HIDE_DELIVERYDAYS';
export const SET_NEW_DELIVERYDAYS = 'SET_NEW_DELIVERYDAYS';
export function toggleDeliveryDays() {
    return {
        type: TOGGLE_DELIVERYDAYS,
    };
}
export function showDeliveryDays() {
    return {
        type: SHOW_DELIVERYDAYS,
    };
}
export function hideDeliveryDays() {
    return {
        type: HIDE_DELIVERYDAYS,
    };
}
